// extracted by mini-css-extract-plugin
export var footer = "_p2-0";
export var inherit = "_p2-1";
export var input = "_p2-2";
export var modalContent = "_p2-3";
export var quillEditor = "_p2-4";
export var subtitle = "_p2-5";